import { render } from "./QuestionThreeScreen.vue?vue&type=template&id=12083196&scoped=true&lang=html"
import script from "./QuestionThreeScreen.vue?vue&type=script&lang=js"
export * from "./QuestionThreeScreen.vue?vue&type=script&lang=js"

import "./QuestionThreeScreen.vue?vue&type=style&index=0&id=12083196&lang=css&scoped=true"

import exportComponent from "/Users/peterdevos/Sites/sthree_grijper/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12083196"]])

export default __exports__